<app-loading *ngIf="contentReady"></app-loading>

<div class="bbm-page">
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar">
            <i
              class="fa-solid fa-right-left"
              aria-hidden="true"
            ></i>
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ 'Stock Transfer History' | transloco }}
            </span>

            <h2>
              {{ 'Stock transfers' | transloco }}
            </h2>

            <p *ngIf="total > 0">
              {{ total }}
              {{ 'requests' | transloco }}
            </p>
          </div>

        </div>

        <div
          class="bbm-hero-counter"
          *ngIf="total > 0"
        >
          <strong>
            {{ total }}
          </strong>

          <span>
            {{ 'requests' | transloco }}
          </span>
        </div>

      </div>

      <div class="bbm-actions-grid bbm-hero-actions noPrint">
        <button
          type="button"
          routerLink="/Stocktransfer"
          class="
            bbm-action-btn
            bbm-action-primary
            bbm-action-wide
          "
        >
          <i
            class="fa-solid fa-plus"
            aria-hidden="true"
          ></i>

          <span>
            {{ 'Stock transfer request' | transloco }}
          </span>
        </button>
      </div>

    </section>

    <!-- ADMIN WAREHOUSE FILTER -->
    <section
      class="bbm-form-ticket"
      *ngIf="isAdmin || superAdmin"
    >
      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'filter by warehouse' | transloco }}
          </span>

          <h3>
            {{ selectedWarehouseName || ('Pospage' | transloco) }}
          </h3>
        </div>
      </div>

      <div class="bbm-field">
        <label>
          {{ 'filter by warehouse' | transloco }}
        </label>

        <div class="dropdown bbm-ticket-menu">

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-primary
              bbm-action-wide
              dropdown-toggle
            "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i
              class="fa-solid fa-warehouse"
              aria-hidden="true"
            ></i>

            <span>
              {{
                selectedWarehouseName ||
                ('Pospage' | transloco)
              }}
            </span>

            <i
              class="fa-solid fa-chevron-down"
              aria-hidden="true"
            ></i>
          </button>

          <ul class="dropdown-menu w-100">

            <li *ngIf="superAdmin">
              <a
                class="dropdown-item"
                (click)="applyWareHouse(null)"
              >
                <i
                  class="fa-solid fa-warehouse"
                  aria-hidden="true"
                ></i>

                <span>
                  {{ 'All warehouses' | transloco }}
                </span>
              </a>
            </li>

            <li *ngFor="let el of allWareHouses">
              <a
                class="dropdown-item"
                (click)="applyWareHouse(el.id, el.name)"
              >
                <i
                  class="fa-solid fa-building"
                  aria-hidden="true"
                ></i>

                <span>
                  {{ el.name }}
                </span>
              </a>
            </li>

          </ul>

        </div>
      </div>
    </section>

    <!-- TRANSFER CARDS -->
    <section
      class="bbm-ticket-list"
      *ngIf="!noData"
    >
      <article
        class="bbm-ticket"
        *ngFor="
          let el of transfers;
          let i = index
        "
      >

        <!-- CARD TOP -->
        <div class="bbm-ticket-top">

          <div class="bbm-main-info">

            <div class="bbm-avatar">
              <i
                class="fa-solid fa-boxes-packing"
                aria-hidden="true"
              ></i>
            </div>

            <div class="bbm-copy">
              <span class="bbm-code-value">
                #{{ el.id }}
              </span>

              <h3>
                {{ 'Transfer Details' | transloco }}
              </h3>
            </div>

          </div>

          <span class="bbm-value-pill">
            <i
              class="fa-regular fa-calendar"
              aria-hidden="true"
            ></i>

            {{ formatDate(el.created_at) }}
          </span>

        </div>

        <!-- WAREHOUSE FLOW -->
        <div class="bbm-details-grid bbm-summary-grid">

          <!-- FROM WAREHOUSE -->
          <div class="bbm-detail-chip bbm-detail-warning">
            <i
              class="fa-solid fa-arrow-up-from-bracket"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'From Warehouse' | transloco }}
            </span>

            <strong>
              {{
                el.from_warehouse?.name ||
                ('not specific' | transloco)
              }}
            </strong>
          </div>

          <!-- TO WAREHOUSE -->
          <div class="bbm-detail-chip bbm-detail-success">
            <i
              class="fa-solid fa-arrow-down-to-bracket"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'To Warehouse' | transloco }}
            </span>

            <strong>
              {{
                el.to_warehouse?.name ||
                ('not specific' | transloco)
              }}
            </strong>
          </div>

        </div>

        <!-- TRANSFER INFORMATION -->
        <div
          class="
            bbm-details-grid
            bbm-ticket-section
          "
        >

          <!-- CREATED BY -->
          <div class="bbm-detail-chip">
            <i
              class="fa-solid fa-user"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'created by' | transloco }}
            </span>

            <strong>
              {{ el.user?.first_name || '' }}
              {{ el.user?.last_name || '' }}
            </strong>
          </div>

          <!-- NOTES -->
          <div class="bbm-detail-chip bbm-detail-wide">
            <i
              class="fa-solid fa-note-sticky"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'note' | transloco }}
            </span>

            <strong>
              {{
                el.notes ||
                ('not specific' | transloco)
              }}
            </strong>
          </div>

        </div>

        <!-- ITEMS -->
        <div class="bbm-products-block">

          <div class="bbm-block-head">
            <span>
              <i
                class="fa-solid fa-boxes-stacked"
                aria-hidden="true"
              ></i>

              {{ 'items' | transloco }}
            </span>

            <b>
              {{ el.items?.length || 0 }}
            </b>
          </div>

          <div class="bbm-products-list">

            <div
              class="bbm-product-row"
              *ngFor="
                let item of el.items;
                let itemIndex = index
              "
            >
              <div class="bbm-product-name">
                <b>
                  {{ itemIndex + 1 }}.
                </b>

                {{
                  item.stock?.name_ar ||
                  item.stock?.name ||
                  item.stock?.name_en ||
                  ('not specific' | transloco)
                }}
              </div>

              <div class="bbm-product-meta">
                <b>
                  {{ 'quantity' | transloco }}
                </b>

                <strong>
                  {{ item.quantity }}
                </strong>
              </div>
            </div>

          </div>

        </div>

      </article>

      <!-- LOADING MORE -->
      <div
        class="bbm-loader"
        *ngIf="isLoadingMore"
      >
        <span
          class="bbm-loader-spinner"
          aria-hidden="true"
        ></span>

        <span>
          {{ 'loading more' | transloco }}
        </span>
      </div>

      <!-- END MESSAGE -->
      <div
        class="bbm-end-state"
        *ngIf="!hasMore && transfers.length > 0"
      >
        {{ 'no more data' | transloco }}
      </div>

    </section>

    <!-- NO DATA -->
    <div
      class="bbm-empty-state"
      *ngIf="noData && !contentReady"
    >
      <app-nodata></app-nodata>
    </div>

  </div>
</div>